




import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CHECK_DEVICE_WHITELISTED, CREATE_IP_ADDRESS, CREATE_KNOWLEDGE_BASE, CREATE_PRODUCT_URl, DELETE_IP_ADDRESS, DELETE_KNOWLEDGE_BASE, DELETE_PRODUCT_URl, GET_Call_DISPOSITION_URl, GET_IP_ADDRESS, GET_KNOWLEDGE_BASE, GET_PRODUCTS_URl, UPDATE_Call_DISPOSITION_URl, UPDATE_IP_ADDRESS, UPDATE_KNOWLEDGE_BASE, UPDATE_PRODUCT_URl, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetknowledgeBaseAll = createAsyncThunk('getknowledgeBaseAll', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 400));
        const response = await FetchData(GET_KNOWLEDGE_BASE, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetknowledgeBaseSlice = createSlice({
    name: 'knowledge Base',
    initialState: {
        knowledgeBase: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetknowledgeBaseAll.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetknowledgeBaseAll.fulfilled, (state, action) => {
                state.knowledgeBase = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetknowledgeBaseAll.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const GetknowledgeBaseDetails = createSlice({
    name: 'Ip Address',
    initialState: {
        knowledgeBaseDetails: ''
    },
    reducers: {
        settknowledgeBaseDetails: (state, action) => {
            state.knowledgeBaseDetails = action.payload;
        }
    }
});

export const AddknowledgeBase = createAsyncThunk('addknowledgeBase', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_KNOWLEDGE_BASE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateknowledgeBase = createAsyncThunk('updateknowledgeBase', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_KNOWLEDGE_BASE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteknowledgeBase = createAsyncThunk('deleteknowledgeBase', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_KNOWLEDGE_BASE, { knowledgeBaseID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessag)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// export const checkDeviceWhiteListed = createAsyncThunk('CheckDeviceIp', async (body, { rejectWithValue }) => {

//     try {
//         const response = await FetchData(CHECK_DEVICE_WHITELISTED, {});

//         if (!response) throw new Error("No response received");

//         if (response.status === 200) {
//             Toast('success', response?.data?.apiStatus?.statusMessage)
//             return 'ok'
//         } else if (response.status === 401) {
//             return rejectWithValue("Unauthorized");
//         } else {
//             return rejectWithValue("Failed to fetch user profile");
//         }
//     } catch (err) {
//         console.log("Error fetching user profile:", err);
//         return rejectWithValue(err.message || "Something went wrong");
//     }
// });



export const { settknowledgeBaseDetails } = GetknowledgeBaseDetails.actions
export {
    GetknowledgeBaseSlice,
    GetknowledgeBaseDetails
};
